import { mobileApiFetch } from '@/mobile/native/mobileApiFetch';

export type MobileSyncRecordPayload = {
  id: string;
  table: string;
  operation: 'insert' | 'update' | 'delete';
  data: Record<string, unknown>;
  updated_at: string;
};

export type MobileSyncResultItem = {
  id: string;
  status: 'synced' | 'conflict' | 'error';
  message?: string;
  server_data?: Record<string, unknown>;
};

export type MobileSyncResponse = {
  results: MobileSyncResultItem[];
};

export class MobileSyncHttpError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly body?: string,
  ) {
    super(message);
    this.name = 'MobileSyncHttpError';
  }
}

export async function postMobileSync(
  records: MobileSyncRecordPayload[],
): Promise<MobileSyncResponse> {
  const response = await mobileApiFetch('/api/mobile/sync', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ records }),
  });

  const text = await response.text();

  if (!response.ok) {
    throw new MobileSyncHttpError(
      text || `HTTP ${response.status}`,
      response.status,
      text,
    );
  }

  return JSON.parse(text) as MobileSyncResponse;
}
